
















import { Prop, Component, Vue } from "vue-property-decorator";
import VariationGraph from "./VariationGraph.vue";
import RangeGraph from "./RangeGraph.vue";

@Component({
  components: { VariationGraph, RangeGraph }
})
export default class Energy extends Vue {
  @Prop() private energy!: Energy;
  @Prop() private duration!: number;
}
